const DEFAULT_FILL_COLOR_NAMES = {
  solid: "semi",
  pattern: "pattern",
  fill: "fill",
  "lined-fill": "linedFill"
};
export {
  DEFAULT_FILL_COLOR_NAMES
};
//# sourceMappingURL=defaultFills.mjs.map
